<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName" @sortChanged="event => emit('sortChanged', event)"
        :actionColumnStyle="actionColumnStyle" @loadMore="emit('loadMore')">
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView.vue'

const emit = defineEmits(['sortChanged', 'loadMore'])

const props = defineProps({
     items:{ type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'ClientName', label: 'client', sortable:true},
    { key: 'RazonSocial', label: 'company', sortable:true},
    { key: 'AcumulaAguinaldo', label: 'bonus'}
])

const actionButtons = ref([])

const actionColumnStyle = ref({ width: '20vw' })

</script>

<style></style>
